import React from "react";
import {MainCP}  from "../../Components/IMACEC-VS-aprob/MainCP"

const ViewIMAprob: React.FC = () => <MainCP/>

export default ViewIMAprob;